/**
 * Blinkit-theme floating cart bar (rendered by StickyCart for Blinkit tenants only): item thumbnails, item count,
 * items total, "View cart". It floats above the bottom navigation and clears the phone's home-indicator / gesture
 * area — the nav grows by ``env(safe-area-inset-bottom)``, so the bar's offset does too.
 */
import { Link } from "react-router-dom";
import { ChevronRight, ShoppingBag } from "lucide-react";
import { fmtInr } from "../../lib/priceBreakdown";
import { cartShopLabel } from "../../lib/multiShop";

export default function BkCartBar({ cart, count }) {
    const thumbs = (cart.items || []).map((i) => i.image_url).filter(Boolean).slice(0, 3);
    const subtotal = cart.totals?.subtotal;
    return (
        <Link
            to="/cart"
            data-testid="sticky-cart-bar"
            // ``desktop-dock`` (index.css): from 1024px there is no bottom tab bar — a compact floating cart, bottom-right.
            className="desktop-dock fixed left-1/2 -translate-x-1/2 z-40 w-[calc(100%-1.5rem)] bg-primary text-primary-foreground rounded-2xl flex items-center gap-3 pl-2.5 pr-2 py-2 shadow-[0_10px_28px_-8px_rgba(15,23,42,0.45)] active:scale-[0.99] transition"
            style={{ maxWidth: "calc(var(--shell-width) - 24px)", bottom: "max(70px, calc(62px + env(safe-area-inset-bottom, 0px)))" }}
        >
            <span className="flex -space-x-3 shrink-0" aria-hidden="true">
                {thumbs.length ? thumbs.map((src, k) => (
                    // Two thumbnails on phones (the count + total must stay readable at 360px), three from sm up.
                    <span key={k} className={`w-10 h-10 rounded-xl bg-card border-2 border-primary overflow-hidden ${k === 2 ? "hidden sm:block" : ""}`}>
                        <img src={src} alt="" className="w-full h-full object-cover" />
                    </span>
                )) : (
                    <span className="w-10 h-10 rounded-xl bg-white/15 flex items-center justify-center"><ShoppingBag size={20} /></span>
                )}
            </span>
            <span className="min-w-0 flex-1 leading-tight">
                <span className="block text-[14px] font-extrabold truncate">{count} item{count === 1 ? "" : "s"}{subtotal != null ? ` · ${fmtInr(subtotal)}` : ""}</span>
                <span className="block text-[11.5px] opacity-85 truncate">{cartShopLabel(cart)}</span>
            </span>
            <span data-testid="sticky-cart-checkout" className="shrink-0 h-10 pl-3 pr-1.5 sm:pl-3.5 sm:pr-2 rounded-xl bg-white/15 inline-flex items-center gap-0.5 text-[13.5px] font-bold">
                View cart <ChevronRight size={18} />
            </span>
        </Link>
    );
}
